"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfiguredBusinessSolutions = void 0;
var _useConfig = _interopRequireDefault(require("../../../hooks/useConfig"));
var _constants = require("../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getConfiguredBusinessSolutions = function getConfiguredBusinessSolutions(newSolutions, newSelectedBusinessSolution) {
  var tabsConfig = (0, _useConfig.default)('recommendTabProducts', {});
  // get all solutions that need to display them in 'Best Match' tab and hide other tabs
  var configSolution = newSolutions === null || newSolutions === void 0 ? void 0 : newSolutions.find(function (s) {
    return s.tier == (_constants.RECOMMENDATION_TIER === null || _constants.RECOMMENDATION_TIER === void 0 ? void 0 : _constants.RECOMMENDATION_TIER.RECOMMENDED) && tabsConfig[s.productId];
  });
  var finalBusinessSolutions = newSolutions;
  if (configSolution) {
    finalBusinessSolutions = newSolutions.filter(function (s) {
      return tabsConfig[configSolution.productId].includes(s.tier);
    });
    newSelectedBusinessSolution.productId = configSolution.productId;
  }
  return finalBusinessSolutions;
};
exports.getConfiguredBusinessSolutions = getConfiguredBusinessSolutions;